import { createRouter, createWebHistory } from 'vue-router';
import Login from '@/views/Login.vue';
import SsoCallback from '@/views/SsoCallback.vue';
import { injectPrivateRoutesByPermission } from './injectPrivateRoutesByPermission';
import {
    getAdminFromStorage,
    resolveDefaultHomePathFromAdmin,
    shouldUseConsultationWorkspaceHome
} from '@/utils/consultantHome';

const publicRoutes = [
    {
        path: '/login',
        component: Login
    },
    {
        path: '/sso-callback',
        component: SsoCallback
    }
    // 404 路由將在動態路由注入後添加，避免在路由未注入時造成循環重定向
];

export const router = createRouter({
    history: createWebHistory(import.meta.env.BASE_URL),
    routes: publicRoutes
});

// 路由守衛
let isInjectingRoutes = false; // 防止重複注入的標記
let routesInjected = false; // 標記路由是否已注入

const PUBLIC_PATHS = new Set(['/login', '/sso-callback']);

router.beforeEach(async (to, from, next) => {
    const accessToken = localStorage.getItem('accessToken');

    // SSO callback 必須可未登入進入，否則成長系統導過來的 code 會被踢回登入頁
    if (!accessToken && !PUBLIC_PATHS.has(to.path)) {
        routesInjected = false; // 清除標記
        next('/login');
        return;
    }

    if (accessToken && to.path === '/login') {
        next(resolveDefaultHomePathFromAdmin(getAdminFromStorage()));
        return;
    }

    if (
        accessToken &&
        to.path === '/dashboard' &&
        shouldUseConsultationWorkspaceHome(getAdminFromStorage()?.roles || [])
    ) {
        next('/consultation-workspace/bookings');
        return;
    }

    if (
        accessToken &&
        to.path === '/consultation-workspace' &&
        shouldUseConsultationWorkspaceHome(getAdminFromStorage()?.roles || [])
    ) {
        next('/consultation-workspace/bookings');
        return;
    }

    // 確保動態路由已加載（只在需要時載入一次）
    if (accessToken && to.path !== '/login' && !isInjectingRoutes && !routesInjected) {
        isInjectingRoutes = true;
        try {
            await injectPrivateRoutesByPermission();
            routesInjected = true;
            // 必須用 next({ ...to }) 強制用「剛註冊的路由」重新匹配，否則子頁不會掛載、也不發 API
            next({ ...to, replace: true });
            return;
        } catch (error) {
            console.error('載入動態路由失敗:', error);
            // 權限 API 失敗（含 429）且無快取時才退回登入，避免誤踢
            localStorage.removeItem('accessToken');
            routesInjected = false;
            next('/login');
            return;
        } finally {
            isInjectingRoutes = false;
        }
    }

    next();
});

export default router;
